import React, { useContext } from 'react';
import { Icon } from '@PetSureAustralia/petsure-react-ui-library/distLib/components';
import { BrandContext } from '../../contextProviders/brandContext';

import './addAPet.scss';

// Note: This will eventually be the wrapper for the quoting capability

export const AddAPet = () => {
  const {
    activeBrandContext: {
      brand: { supportEmailAddress, supportPhoneNumber }
    }
  } = useContext(BrandContext);

  return (
    <section className="addAPet">
      <div className="petIcons">
        <Icon icon="dog-profile" />
        <Icon icon="cat-profile" />
      </div>

      <h4 className="addAPetHeading">
        <span className="avoidLineBreak">Would you like to insure another pet?</span>
        <span className="avoidLineBreak">Please contact us to arrange cover.</span>
      </h4>

      <big className="supportPhoneNumber">{supportPhoneNumber}</big>

      <a
        className="supportEmail"
        rel="noreferrer"
        href={`mailto:${supportEmailAddress}`}
      >
        {supportEmailAddress}
      </a>
    </section>
  );
};
